import React from 'react';
import ErrorBoundary from 'components/common/ErrorBoundary';
import ConfigurationSidebar from './sidebar/ConfigurationSidebar';
import { saveConfiguration } from './helpers';
import defaultChartConfiguration from './defaultChartConfiguration';
import { ConfiguredReport } from 'components/reporting/sidebar/ConfiguredReport';
import Chart from './charts/Chart';
import ChartDimensions from './ChartDimensions';
import { determineDataTypeForAxisOld, determineDataTypeForAxis } from './util';

function EditableChart({ data, configuration, meta, chartType }) {
  // Helper function to determine data type for an axis
  function dataTypeForAxis(axis) {
    return window.featureFlags.SUPPORT_579_better_sorting_for_pivot_chart
      ? determineDataTypeForAxis(data, chartType, meta)
      : determineDataTypeForAxisOld(data, chartType, meta, ''); // For EditableChart, we don't have a sort axis, so pass empty string
  }
  return (
    <ErrorBoundary>
      <ConfiguredReport
        meta={meta}
        defaultConfiguration={defaultChartConfiguration(chartType)}
        configuration={configuration}
        onChange={newConfiguration => {
          saveConfiguration({
            configuration: { configuration_nivo_options: newConfiguration },
            bookmarkId: meta.bookmarkId,
          });
        }}
      >
        <ChartDimensions meta={meta}>
          {({ measureRef, width, height }) => (
            <div
              style={{
                flexBasis: 0,
                flexGrow: 999,
                minWidth: 0,
                alignItems: 'center',
                justifyContent: 'center',
                display: 'flex',
                background: 'var(--theme-tertiary-background)',
              }}
            >
              <div
                id='custom-chart-body'
                data-chart-type={chartType}
                ref={measureRef}
                style={{
                  position: 'relative',
                  width: '90%',
                  height: '90%',
                  background: 'var(--theme-primary-background)',
                  border: '1px solid var(--theme-secondary-border)',
                  borderRadius: 4,
                  boxShadow: '0 2px 10px rgb(0 0 0 / 15%)',
                  overflow: 'hidden',
                }}
              >
                {width && height && (
                  <Chart
                    data={data}
                    meta={meta}
                    chartType={chartType}
                    width={width}
                    height={height}
                    publishing={false}
                  />
                )}
              </div>
            </div>
          )}
        </ChartDimensions>
        <ConfigurationSidebar
          chartType={chartType}
          meta={meta}
          horizontalSortType={dataTypeForAxis('x')}
          verticalSortType={dataTypeForAxis('y')}
        />
      </ConfiguredReport>
    </ErrorBoundary>
  );
}
export default EditableChart;
